// extracted by mini-css-extract-plugin
export default {"languageSelector":"languageSelector_languageSelector__6AAD8"};